import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/user/blogs/blogs.css";
import { Container, Spinner } from "react-bootstrap";
import Navbar from "../navbar/Navbar";
import SimpleBanner from "../general/SimpleBanner";
import Footer from "../footer/Footer";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import MarqueeBanner from "../Marqueebanner/Marqueebanner";
import MyNavbar from "../navbar/Navbar";

const ArrowUpRight = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 17L17 7M7 7h10v10" />
  </svg>
);

const BlogCard = ({ post, index, baseUrlForFiles }) => {
  const navigate = useNavigate();

  const categoryClass =
    {
      Beauty: "lb-cat-beauty",
      Business: "lb-cat-business",
      Technology: "lb-cat-technology",
    }[post.category] || "";

  return (
    <article
      className="lb-card"
      onClick={() => navigate(`/blog/detail/${post.id}`)}
      role="button"
      tabIndex={0}
      style={{ cursor: "pointer" }}
    >
      {/* Image */}
      <div className="lb-card-image-wrapper">
        <img
          src={`${baseUrlForFiles}/${post.image}`}
          alt={post.title}
          loading="lazy"
        />

        <div className="lb-card-image-overlay" />

        <span className={`lb-card-category ${categoryClass}`}>
          {post.category || "Blog"}
        </span>

        <div className="lb-card-number">
          {String(index + 1).padStart(2, "0")}
        </div>
      </div>

      {/* Body */}
      <div className="lb-card-body">
        <h3 className="lb-card-title">{post.title}</h3>

        <div
          className="lb-card-excerpt"
          dangerouslySetInnerHTML={{ __html: post.description }}
        />

        <div className="lb-card-footer">
          <div className="lb-card-author">
            <div className="lb-author-avatar">AD</div>

            <div className="lb-author-info">
              <span className="lb-author-name">Admin</span>

              <span className="lb-author-date">
                {new Date(post.created_at).toLocaleDateString("en-GB")}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Button */}
      <button
        className="lb-card-read-more"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/blog/detail/${post.id}`);
        }}
      >
        Read More <ArrowUpRight />
      </button>
    </article>
  );
};

const Blogs = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [blogs, setBlogs] = useState([]);
  const [oldImage, setOldImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [visibleBlogs, setVisibleBlogs] = useState(6);

  // ---------------- FETCH BLOGS ----------------
  const fetchAllBlogs = () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("limit", 8);

    axios
      .post(
        // `${baseUrl}/customer/blog/fetchAllBlogs`
        `${baseUrl}/customer/blog/fetchLatestBlogs`,
        formData,
        { headers: { "Content-Type": "multipart/formData" } },
      )
      .then((res) => {
        console.log("Blogs Response:", res.data);

        if (res.data.success === true) {
          console.log("First Blog Image:", res.data.blogs[0]?.image);

          setBlogs(res.data.blogs);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAllBlogs();
  }, []);

  return (
    <>
      <MarqueeBanner />
      <MyNavbar />

      <SimpleBanner
        title="Blogs"
        subtitle=""
        breadcrumbs={[
          {
            label: "Home",
            href: "/",
          },
          {
            label: "blogs",
            href: "/blog",
          },
        ]}
      />
      <Container fluid>
        <section className="lb-section" id="blog">
          <div className="lb-container">
            <div className="lb-header">
              <div className="lb-header-left">
                <h2 className="lb-title">Blog</h2>

                <p className="lb-subtitle">
                  News, tips and insights from Time4Pulse.
                </p>
              </div>
            </div>

            {/* Loading */}
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" />
              </div>
            ) : blogs.length === 0 ? (
              <div className="text-center py-5">No Blogs Found</div>
            ) : (
              <>
                <div className="lb-grid">
                  {blogs.slice(0, visibleBlogs).map((post, index) => (
                    <BlogCard
                      key={post.id}
                      post={post}
                      index={index}
                      baseUrlForFiles={baseUrlForFiles}
                    />
                  ))}
                </div>

                {visibleBlogs < blogs.length && (
                  <div className="text-center mt-4">
                    {/* <button className="lb-view-all" onClick={() => navigate("/blog")}>
            View All <ArrowRight />
          </button> */}
                    <button
                      className="lb-view-all"
                      onClick={() => setVisibleBlogs((prev) => prev + 6)}
                    >
                      Load More
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </section>
      </Container>
      <Footer />
    </>
  );
};

export default Blogs;
